<template>
  <div class="about-page">
    <!-- About Background Section -->
    <section class="whaybest faq-bg">
      <div class="fadeIn">
        <img class="faq-img" src="/static/images/about-min.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/about%402x.png" alt="About Background" ref="lazyImg" />
        <div class="faq-line"></div>
        <div class="faq-title">ABOUT US</div>
      </div>
    </section>

    <!-- About Content -->
    <div class="container">
      <div class="row">
        <div class="col-lg-12 about-content">
          <p>Anovator, established in November 2013, we are an innovation-driven human body data service company,We are committed to providing accurate, scientific, comprehensive and convenient human body data services for global health industry users. We use cutting-edge AI and IOT to evaluate different items for people of different age groups. It covers: body composition,blood pressure, blood oxygen, static heart rate, limit heart rate, lung capacity, balance ability, quick response, vision screening, body posture risk and other items. The product will automatically collect various body data, generate accurate and reliable body data reports, and provide data API.</p>
          <p>The Anovator Body Data Analyzer is widely used in commercial fitness and health fields. We have provided high-quality human body data services to customers such as gyms, children's sports halls, clinics and health centers in more than 10 countries and regions around the world. Feedback from users in the United States, Canada, Spain, and Singapore is of great help to it in the fields of fitness, sports rehabilitation, and healthy growth of children.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  name: 'About',
  mixins: [lazyLoadingMixin],
  mounted() {
    // Set page title
    document.title = 'About Us - Anovator';
  }
}
</script>

<style scoped>
.container{
  margin-top: 50px;
}
/* Vue特定的样式，使用与原始网站一致的样式 */
.about-page {
  min-height: 100vh;
}

.about-content {
  padding: 8vh;
  color: #333;
  line-height: 1.6;
}

.about-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
}
.faq-img{
  z-index: 2;
}
</style>